<script setup lang="ts">

</script>

<template>
  <div class="absolute h-[3px] overflow-x-hidden">
    <div class="absolute opacity-40 bg-transparent w-[150%] h-2" />
    <div class="subline h-full inc" />
    <div class="subline h-full dec" />
  </div>
</template>

<style scoped>
  .subline {
    position: absolute;
    background: theme('colors.csBlue.200');
  }

  .inc {
    animation: increase 3.25s infinite;
  }

  .dec {
    animation: decrease 3.25s 1s infinite;
  }

  @keyframes increase {
    from { left: -5%; width: 5%; }
    80%, 100% { left: 130%; width: 100%;}
  }
  @keyframes decrease {
    from { left: -80%; width: 80%; }
    80%, 100% { left: 110%; width: 10%;}
  }
</style>